import IgManageShell from "@/components/IgManageShell";
import InstagramUserUploads from "@/components/InstagramUserUploads";

export default function InstagramUserReview() {
  return (
    <IgManageShell need="uploads" title="User Upload Review">
      <div data-testid="ig-user-review-page">
        <InstagramUserUploads />
      </div>
    </IgManageShell>
  );
}
